<p-toast
  position="top-center"
  key="lake-front"
  [preventOpenDuplicates]="true"
></p-toast>

<p-toast
  position="top-center"
  key="confirm"
  [baseZIndex]="5000"
  styleClass="w-max"
>
  <ng-template let-message pTemplate="message">
    <div class="flex flex-column justify-content-center">
      <div class="align-self-center w-max">
        {{ message.summary }}
      </div>
      <div class="flex justify-content-center pt-2">
        <p-button
          styleClass="m-2 p-button-outlined text-blue-600 "
          (click)="dataContextWaitingService.mark(message.data.dcId, false)"
          >No</p-button
        >
        <p-button
          styleClass="m-2 text-black"
          (click)="dataContextWaitingService.mark(message.data.dcId, true)"
          >Yes</p-button
        >
      </div>
    </div>
  </ng-template>
</p-toast>
<router-outlet></router-outlet>
